//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/View.js";
let d=[[],[[["shade_color","partial_shading","translucency_option","translucency_scale","objects"],"ApplyShadeEdit",{},5,0],[["partial_shading","translucency_option","translucency_scale","objects"],"ApplyShadeEdit1",{},4,0],[["color","font","width","objects"],"ApplyWireframeEdit",{},4,0],[["font","width","objects"],"ApplyWireframeEdit1",{},3,0],[["object","color","font","width","segment_start","segment_end"],"ApplySegmentEdit",{},6,0],[["object","font","width","segment_start","segment_end"],"ApplySegmentEdit1",{},5,0],[["objects"],"Erase",{},1,0],[["objects"],"RemoveErasure",{},1,1],[["objects","removeFromSubObjects"],"RemoveErasureOnObjectAndSubobjects",{},2,0],[["objects"],"RemoveEdit",{},1,0],[[],"RemoveAllEdits",{},0,0],[["objects"],"MoveToModel",{},1,0],[["objects"],"MoveToView",{},1,0],[["objects"],"SetBackground",{},1,0]],[]];
SPLM.ViewDependentDisplayManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.ViewDependentDisplayManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ViewDependentDisplayManager.Font = Object.freeze({
    "Invisible" : "Invisible", "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "Centerline" : "Centerline", "Dotted" : "Dotted", "LongDashed" : "LongDashed", "DottedDashed" : "DottedDashed", "Object" : "Object", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

SPLM.ViewDependentDisplayManager.Width = Object.freeze({
    "Normal" : "Normal", "Thick" : "Thick", "Thin" : "Thin", "Object" : "Object", "One" : "One", "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six", "Seven" : "Seven", "Eight" : "Eight", "Nine" : "Nine"});

SPLM.ViewDependentDisplayManager.PartialShading = Object.freeze({
    "NoChange" : "NoChange", "Original" : "Original", "No" : "No", "Yes" : "Yes"});

SPLM.ViewDependentDisplayManager.Translucency = Object.freeze({
    "NoChange" : "NoChange", "Original" : "Original", "Yes" : "Yes"});

export default SPLM;